module.exports = __webpack_public_path__ + "assets/word_cloud_visit_defalut.1b3a43c6.svg";